import axios from 'axios';
import queryString from 'query-string';
import { processedQueryString } from '@/_vue/helpers/processed-query-string';

const state = {
    baseUrl: window.location.pathname,
    filters: [],
    filtersRoute: null,
    isLoading: true,
    query: {
        article_number: '',
        brand_search: '',
        limit: 18,
        page: 1,
        q: '',
        sort: 'popular',
        ...processedQueryString(),
    },
    queryDefaults: {
        article_number: '',
        brand_search: '',
        limit: 18,
        page: 1,
        q: '',
        sort: 'popular',
    },
    queryPurged: {},
    results: [],
    resultsRoute: null,
    resultsTotal: 0,
};

const purgedQuery = query => Object
    .keys(query)
    .reduce((queryItem, key) => {
        query[key] && (queryItem[key] = query[key]); // eslint-disable-line

        return queryItem;
    }, {});

const getters = {
    activeFilters: (state) => {
        const filterArrays = Object.values(state.query).filter(item => Array.isArray(item));
        return []
            .concat(...filterArrays.map(item => item))
            .concat(state.query.article_number)
            .concat(state.query.brand_search)
            .filter(item => item !== '');
    },

    categories: state => state.filters.filter(item => item.type === 'category'),

    categoriesExcluded: state => state.filters.filter(item => item.type !== 'category'),

    pageCount: (state) => {
        const pageRangeStart = Math.max((state.query.page - 1) * state.query.limit, 1);
        const pageRangeEnd = Math.min((state.query.page * state.query.limit), state.resultsTotal);

        return `${pageRangeStart} - ${pageRangeEnd}`;
    },
};

const actions = {
    async getFilters({ commit, dispatch }) {
        const { data } = await axios.get(state.filtersRoute, { params: purgedQuery(state.query) });
        commit('setFilters', data);
        commit('setQuery', data);
        dispatch('getResults');
    },

    async getResults({ commit }) {
        commit('setLoading');

        const { data } = await axios.get(state.resultsRoute, { params: purgedQuery(state.query) });
        commit('setResults', data);
        commit('updateQuery');
    },

    getPage({ commit, dispatch }, data) {
        commit('setPage', data);
        commit('updateQuery');
        dispatch('getResults');
    },

    resetFilters({ commit }) {
        commit('clearFilters');
    },
};

const mutations = {
    clearFilters(state) {
        const setQueryFilters = state.filters
            .map(item => item.key)
            .reduce((obj, item) => {
                obj[item] = [];

                return obj;
            }, {});

        state.query = Object.assign(setQueryFilters);
    },

    updateQuery(state, query) {
        state.query = { ...state.query, ...query };
        state.queryPurged = purgedQuery(state.query);

        window.history.replaceState({}, '', state.baseUrl + `?${queryString.stringify(state.queryPurged, { arrayFormat: 'bracket' })}`);
    },

    setPage(state, page) {
        state.query.page = page;
        window.scrollTo(0, 0);
    },

    setLoading(state) {
        state.isLoading = true;
    },

    setFilters(state, data) {
        state.filters = data;
    },

    setFiltersDefaults(state, data) {
        state.filtersRoute = data.filtersRoute;
        state.resultsRoute = data.resultsRoute;

        if (data.limit) {
            state.query.limit = data.limit;
            state.queryDefaults.limit = data.limit;
        }
    },

    setQuery(state, data) {
        const setQueryFilters = data
            .map(item => item.key)
            .reduce((obj, item) => {
                obj[item] = [];

                return obj;
            }, {});

        const queryMerged = Object.assign(
            setQueryFilters,
            processedQueryString(),
        );

        state.query = { ...state.query, ...queryMerged };
        state.queryDefaults.q = state.query.q;
        state.queryPurged = purgedQuery(state.query);
    },

    setResults(state, data) {
        state.results = data.results;
        state.resultsTotal = data.total_results;
        state.isLoading = false;
    },
};

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
